import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d11aa83&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2d11aa83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d11aa83",
  null
  
)

export default component.exports